import { Component, OnInit, Input, ViewEncapsulation, Renderer2 } from '@angular/core';
import { PropertyListItem } from "../../property";
import { listPriceHistory} from "../../propertyChangeLog";
import {OverlayPanelModule, OverlayPanel } from 'primeng/overlaypanel';
import { GlobalService } from '../../../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../../../environments/environment';
import { propertyChangeLogService } from '../../PropertyChangeLog.service';
import { FavoritePropertiesService } from '../../favorite-properties.service';

@Component({
  selector: 'tpl-property-search-reo',
  templateUrl: './search-reo.component.html',
  styleUrls: [
    '../templates.scss',
    './search-reo.component.scss'
  ],
  encapsulation: ViewEncapsulation.None

})
export class SearchReoComponent implements OnInit {
  @Input() routes: any = {};
  @Input() iconLeft: string;
  @Input() showPropertyIdLink: boolean;
  @Input() showListPriceHover: boolean;
  @Input() showOpenNewWindowIcon: boolean;
  @Input('value') property: PropertyListItem;
  listPriceChangeLog: listPriceHistory[];
  canAccessListPrice = this._global.find((<any>_GlobalNS).paths.canAccessListPrice);
  loading: boolean;
  moreDialogData: string = '';
  favoriteLoansUpdateData: any[];
  MyFavoritePropertiesCount = this._global.find((<any>_GlobalNS).paths.UserFavoritePropertiesCount);
  UserFavoritePropertiesMaxCount = this._global.find((<any>_GlobalNS).paths.UserFavoritePropertiesMaxCount);

  constructor( private changeLogSvc: propertyChangeLogService
    , private _global: GlobalService
    , private render: Renderer2
    , private favoritePropertiesService: FavoritePropertiesService) {

      favoritePropertiesService.getFavoritesCount().subscribe(count => {
        this.MyFavoritePropertiesCount = count;
      });
    }

  ngOnInit() {
    this.showPropertyIdLink = (this.showPropertyIdLink === undefined) ? false : true;
    this.showOpenNewWindowIcon = (this.showOpenNewWindowIcon === undefined) ? false : true;

    if (this.property === undefined || typeof this.property !== 'object'){
      console.log(new TypeError('@Input value is undefined'));
    }
  }

  // Logic for list price hover and setting the ListPriceChangeLog object
  listPriceHover(event, overlayPanel: OverlayPanel, objectId: Number) {
    this.loading = true;
    this.changeLogSvc.find(objectId)
      .subscribe((listPriceData: listPriceHistory[]) => {
        this.listPriceChangeLog = (<any>listPriceData).data;
        overlayPanel.toggle(event);
        this.loading = false;
      });
  }

    /*
	status Label- based on Substatus has a value or not
	*/
    statusLabel(status: string, substatus: string): string {
      return ((substatus !== null) ? 'Status/Alt Status' : 'Status');
    }

   /*
	status Value- based on Status/ Substatus has a value or not
	*/
    statusDisplayValue(status: string, subStatus: string): string {
      const hasMore = this.canShowMoreStatus(status, subStatus);
      const statusLabel = (subStatus !== null) ? `${status.trim()} / ${subStatus.trim()}` : status.trim();
      return (hasMore ? statusLabel.substring(0, 20) : statusLabel);
    }

    /* show/hide status/substatus ...(more)  button */
    canShowMoreStatus(status: string, subStatus: string): boolean {
      const statusLength = (subStatus !== null ? subStatus.trim().length : 0) + status.trim().length;
      return statusLength > 25 ? true : false;
    }

    /* display [...] hover over message */
    displayMoreDialog(event, moreDialog, moreDialogData, moreType): void {
      if (moreType === 'status') {
        this.moreDialogData = `${moreDialogData.StatusLabel} / ${moreDialogData.SubStatusLabel}`;
      }
      moreDialog.show(event);
    }

    getFavIconClass(IsFavorite: number): any {
      if (IsFavorite === 1) {
        return 'fas fa-heart fav-heart-loan-selected';
      } else {
        return 'far fa-heart';
      }
    }

    updateFavorite(el: any, propertyId: number): void {
      let proceedToUpdate = false;
      const favIconId = el.getAttribute('data-fav-loan-icon-id');
      const isFavFlag = el.getAttribute('data-fav-loan-flag');
      if (isFavFlag === '1') {
        // -- Remove from favs
        this.render.removeAttribute(el, 'class');
        this.render.addClass(el, 'far');
        this.render.addClass(el, 'fa-heart');
        el.setAttribute('data-fav-loan-flag', '0');
        proceedToUpdate = true;
      } else {
        // -- Add to favs
        if (this.MyFavoritePropertiesCount < this.UserFavoritePropertiesMaxCount) {
          this.render.addClass(el, 'fas');
          this.render.addClass(el, 'fa-heart');
          this.render.addClass(el, 'fav-heart-loan-selected');
          el.setAttribute('data-fav-loan-flag', '1');
          proceedToUpdate = true;
        } else {
          this.favoritePropertiesService.setDisplayMaxFavCountErrorMessageDialog(true);
        }
      }

      if (proceedToUpdate) {
        this.favoritePropertiesService.updateFavorites(propertyId, el.getAttribute('data-fav-loan-flag'))
          .subscribe((res) => {
            this.favoriteLoansUpdateData = (<any>res).data;
            this.favoritePropertiesService.setFavoritesCount(this.favoriteLoansUpdateData[0].CurrentCount);
            this.favoritePropertiesService.setReloadFavoritePropertiesBar(true);
          }, (error) => {
           console.log('Couldnot update favorites');
        });
      }
    }
}
